import React, { useEffect, useRef, useState } from 'react';
import MDBox from "ui/MDBox";
import MDTypography from "ui/MDTypography";
import MDInput from "ui/MDInput";
import MDButton from "ui/MDButton";
import MDAlert from "ui/MDAlert";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Card, FormControl, FormGroup, FormControlLabel, Checkbox, Icon } from "@mui/material";
import roleService from 'services/role-service';

const CreateRoles = () => {
  const [notification, setNotification] = useState(false);
  const [rolesData, setRolesData] = useState({
    name: '',
    permissions: [],
  });
  const [permissions, setPermissions] = useState([]);
  const [errors, setErrors] = useState({
    nameError: false,
    permissionsError: false,
  });

  const formRef = useRef(null); // Create a reference for the form

  useEffect(() => {
    if (notification) {
      const timer = setTimeout(() => {
        setNotification(false);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [notification]);

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setRolesData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Fetch permissions from the API
  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const response = await roleService.getpermissions();
        console.log('Permissions API Response:', response);
        if (response.success) {
          setPermissions(response.permissions);
        } else {
          console.error('Error fetching permissions:', response.message);
        }
      } catch (error) {
        console.error('API call failed:', error);
      }
    };
    fetchPermissions();
  }, []);

  const handleCheckboxChange = (e) => {
    const { value } = e.target;
    setRolesData((prevData) => {
      const currentPermissions = prevData.permissions.includes(value)
        ? prevData.permissions.filter((permission) => permission !== value)
        : [...prevData.permissions, value];

      return {
        ...prevData,
        permissions: currentPermissions,
      };
    });
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    setErrors({
      nameError: false,
      permissionsError: false,
    });

    if (rolesData.name.trim().length === 0) {
      setErrors((prev) => ({ ...prev, nameError: true }));
      return;
    }

    if (rolesData.permissions.length === 0) {
      setErrors((prev) => ({ ...prev, permissionsError: true }));
      return;
    }

    // Prepare roles data for the API call
    const newRoleData = {
      name: rolesData.name,
      permissions: rolesData.permissions,
    };

    const response = await roleService.create(newRoleData);
    if (response.success) {
      setNotification({ type: 'success', message: response.message });
      setRolesData({
        name: '',
        permissions: [],
      });
    } else {
      setNotification({ type: 'error', message: response.message });
    }
  };

  const handleHeaderSaveClick = () => {
    if (formRef.current) {
      formRef.current.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
    }
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={2} pt={5} pb={3} />
      <Card>
        <MDBox
          mx={2}
          mt={-3}
          py={3}
          px={2}
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <MDTypography variant="h6" color="white">
            Add Role
          </MDTypography>
          <MDButton color="light" type="submit" onClick={handleHeaderSaveClick}>
            <Icon sx={{ fontWeight: "bold" }}>save</Icon>
            &nbsp;
            Save
          </MDButton>
        </MDBox>

        <MDBox
          component="form"
          role="form"
          ref={formRef} // Attach the ref to the form=
          onSubmit={submitHandler}
          display="flex"
          flexDirection="column"
          py={3}
          px={3}
        >

          {notification && (
            <MDAlert color={notification.type} mt="20px">
              <MDTypography variant="body2" color="white">
                {notification.message}
              </MDTypography>
            </MDAlert>
          )}

          <MDBox display="flex" flexDirection="row" mt={5} mb={3}>
            <MDBox display="flex" flexDirection="column" alignItems="flex-start" width="100%" mr={2}>
              <MDTypography variant="body2" color="text" ml={1} fontWeight="regular">
                Name
              </MDTypography>
              <MDBox display="flex" flexDirection="column" width="100%" mr={2}>
                <MDInput
                  type="text"
                  name="name"
                  value={rolesData.name}
                  onChange={changeHandler}
                  error={errors.nameError}
                />
                {errors.nameError && (
                  <MDTypography variant="caption" color="error">
                    Name is required
                  </MDTypography>
                )}
              </MDBox>
            </MDBox>

          </MDBox>

          {/* Permissions Section with Border and Padding */}
          <MDBox

            p={2}
            mb={3}
          >
            <MDTypography variant="h6" mb={2}>
              Permissions
            </MDTypography>
            <FormControl error={errors.permissionsError}>
              <FormGroup>
                {/* Permissions Wrapper */}
                <MDBox display="flex" justifyContent="space-between" flexWrap="wrap" mb={2}>
                  {permissions.map((permission, index) => (
                    <FormControlLabel
                      key={permission}
                      control={
                        <Checkbox
                          checked={rolesData.permissions.includes(permission)}
                          onChange={handleCheckboxChange}
                          value={permission}
                        />
                      }
                      label={permission}
                      sx={{
                        width: '30%',
                        marginBottom: '16px',
                        border: 1,
                        borderColor: 'grey.300',
                        borderRadius: 2,
                        padding: 1,
                      }}
                    />
                  ))}
                </MDBox>
              </FormGroup>
              {errors.permissionsError && (
                <MDTypography variant="caption" color="error">
                  Permissions are required
                </MDTypography>
              )}
            </FormControl>
          </MDBox>
        </MDBox>
      </Card>
    </DashboardLayout>
  );
};

export default CreateRoles;
